import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import OrganisationCreditsView from './OrganisationCreditsView';
import SidePanel from 'front-onceforall-core/dist/views/SidePanel';
import { authenticationService } from '../../../services/authentication/AuthenticationService';
import CreditsEditor from './creditsEditor/CreditsEditorForm';
import { Translate } from 'react-redux-i18n';
import { captureError } from '../../../utils/log';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const OrganisationCreditsContainer = _ref => {
  let {
    actions,
    organisation
  } = _ref;
  const subscription = useSelector(state => state.subscription) || {};
  const credits = subscription.credits || null;
  const loading = subscription.isFetching || false;
  const [error, setError] = React.useState(false);
  const [isPanelOpen, setIsPanelOpen] = React.useState(false);
  const isBackOffice = authenticationService.roles().isBackOffice();
  let triggerClosePanel = () => {
    setIsPanelOpen(false);
  };
  const handleUpdateCredits = updatedCredits => {
    if (updatedCredits.projectCredits === credits?.projectCredits && updatedCredits.requestForApprovalCredits === credits?.requestForApprovalCredits) {
      triggerClosePanel();
      return;
    }
    actions.updateSubscriptionCredits(updatedCredits).then(() => {
      actions.addSuccess(/*#__PURE__*/_jsx(Translate, {
        value: "organisation.page.updateSuccess",
        organisationName: organisation.fullName
      }));
    }).catch(error => {
      captureError('handleUpdateCredits', error);
      actions.addError(/*#__PURE__*/_jsx(Translate, {
        value: "error.generic"
      }));
    }).finally(() => {
      triggerClosePanel();
    });
  };
  const fetchOrganisationCredits = () => {
    actions.fetchSubscription(true).catch(() => {
      setError(true);
    });
  };
  React.useEffect(() => {
    if (organisation) {
      fetchOrganisationCredits();
    } else {
      setError(true);
    }
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(OrganisationCreditsView, {
      organisation: organisation,
      credits: credits,
      loading: loading,
      error: error,
      onPanelAction: setIsPanelOpen,
      isUserBackOffice: isBackOffice
    }), isPanelOpen && /*#__PURE__*/_jsx(SidePanel, {
      setCloseTrigger: closeFunction => {
        triggerClosePanel = closeFunction;
      },
      onClose: () => setIsPanelOpen(false),
      children: /*#__PURE__*/_jsx(CreditsEditor, {
        credits: credits,
        onCancel: () => triggerClosePanel(),
        onValidate: handleUpdateCredits
      })
    })]
  });
};
OrganisationCreditsContainer.propTypes = {
  organisation: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};
export default OrganisationCreditsContainer;